import React, { useState, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './CreateNews.css';
import { FaCloudUploadAlt } from "react-icons/fa";

function CreateNews() {
    const [file, setFile] = useState();
    const [name, setName] = useState('');
    const [position, setPosition] = useState('');
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!name.trim()) {
            setError('กรุณากรอกชื่อ-สกุล');
            return;
        }

        const formdata = new FormData();
        formdata.append('file', file);
        formdata.append('name', name);
        formdata.append('position', position);
        formdata.append('email', email);
        console.log(formdata);
        //test console.log

        try {
            await axios.post('https://school-web-server-eight.vercel.app/createNews', formdata, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            navigate('/login');
        } catch (err) {
            console.error('Can\'t create staff:', err);
            setError('Can\'t to create staff');
        }
    };

    const inputRef = useRef(null);
    const handleImageClick = () => {
        inputRef.current.click();
    };
    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (!file || file.length === 0) {
            console.error("No file selected.");
            return;
        }
        const imgname = event.target.files[0].name;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            const img = new Image();
            img.src = reader.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.toBlob(
                    (blob) => {
                        const file = new File([blob], imgname, {
                            type: "image/png",
                            lastModified: Date.now(),
                        });

                        console.log(file);
                        setFile(event.target.files[0]);
                    },
                    "image/png",
                    0.8
                );
            };
        };
    };

    return (
        <>
            <form onSubmit={handleSubmit} className='news'>
                <div className='manageNews'>จัดการข่าวประชาสัมพันธ์</div>
                <h2 className='updateNews'>ข่าวประชาสัมพันธ์สำคัญ</h2>
                <div className='mb-2'>
                    {error && <p className="text-danger">{error}</p>}
                </div>
                <div className='frame1'></div>
                <div className='ac-2'>
                    <div className="image2" onClick={handleImageClick} style={{ cursor: "pointer" }}>
                        <div className="imgupload">
                            {file ? (
                                <img src={URL.createObjectURL(file)} alt="" />
                            ) : (
                                <FaCloudUploadAlt size={50} />
                            )}
                        </div>
                        <input
                            type="file"
                            ref={inputRef}
                            onChange={handleImageChange}
                            style={{ display: "none" }} />
                    </div>
                </div>
                
                <div className='title'>
                <label htmlFor="name">เรื่อง</label>
                    <input
                        type="text"
                        placeholder='หัวข้อประชาสัมพันธ์'
                        className='form-control'
                        value={name}
                        onChange={(e) => {
                            setName(e.target.value); 
                            setError('');
                            e.target.setCustomValidity('');
                        }}
                        onInvalid={(e) => e.target.setCustomValidity('กรุณากรอกหัวข้อประชาสัมพันธ์')}
                        required
                    />
                </div>

                <div className='dateup'>
                <label htmlFor="position">วันที่อัปโหลด</label>
                    <input
                        type="date"
                        className='form-control'
                        value={position}
                        onChange={(e) => setPosition(e.target.value)}
                    />
                </div>
                <div className='link'>
                <label htmlFor="link">ลิ้งค์อัปโหลดเอกสาร</label>
                    <input
                        type="url"
                        placeholder='Enter URL'
                        className='form-control'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                <button className='addinfo'>เพิ่มข้อมูล</button>
                <button type="button" className='backhome' onClick={() => navigate('/login')}>กลับหน้าหลัก</button>
            </form>
        </>
    );
}


export default CreateNews;
